import { render, staticRenderFns } from "./shopClassify.vue?vue&type=template&id=382739b0&"
import script from "./shopClassify.vue?vue&type=script&lang=js&"
export * from "./shopClassify.vue?vue&type=script&lang=js&"
import style0 from "./shopClassify.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports